module.exports = {
	"dk": []
};


//////////////////
// WEBPACK FOOTER
// ./src/config/podcastConfig.json
// module id = 903
// module chunks = 1 2